'use client'

function share(param) {
    navigator
        .share(param)
        .catch(err => {
            const isAbortError = err instanceof DOMException && err.name === 'AbortError'
            if (!isAbortError) {
                throw new Error('Unexpected error when attempting to share.', {cause: err})
            }
        })

}

export default function ShareButton({shareUrl, shareUrlTitle}) {
    return (
        <button
            onClick={() => share({url: shareUrl, title: shareUrlTitle})}
            className={'w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center'}>
            <img width={22} height={23} src={'/square.and.arrow.up.svg'} alt={'share'}/>
        </button>
    )
}
